<template lang="pug">
.Youtube
  div(:id="id")
</template>

<script>
import YP from 'youtube-player';

export default {
  name: 'Youtube',
  props: {
    id: {
      type: String,
      default: 'video-player',
    },
    videoIdList: {
      type: [String, Array],
      default: '',
    },
  },
  data() {
    return {
      player: null,
    };
  },
  created() {
    window.addEventListener('resize', this.resize);
  },
  mounted() {
    this.player = YP(this.id, {
      width: window.innerWidth,
      height: window.innerHeight,
      playerVars: {
        rel: 0,
        fs: 0,
        controls: 0,
        autoplay: 1,
        loop: 1,
        playlist: Array.isArray(this.videoIdList) ? this.videoIdList.join() : this.videoIdList,
      },
    });

    this.player.playVideo();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    resize() {
      const { innerWidth, innerHeight } = window;
      this.player.setSize(innerWidth, innerHeight);
    },
  },
};
</script>

<style lang="sass">
</style>
